module.exports = __webpack_public_path__ + "static/media/012-woman-2.2232537b.svg";